import PagesTabs from "./tabs";
import {POC_CLOUD_CONSTANTS} from "@/components/header/header.constants";

const PocCloudTabs = () => {
  return <PagesTabs props={POC_CLOUD_CONSTANTS} />;
};

export default PocCloudTabs;
